import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'
import {useSafeCallbackExtraDeps, unCallbackFn} from '@freckle/react-hooks'

import {type IdpOverlayStudentPOST} from '@frontrow/console/src/models/idp-overlay-student.types'
import * as style from './idp-overlay-student-create-button-modal.module.scss'
import IdpOverlayStudentForm from '@frontrow/console/src/components/pages/roster-page/idp-overlay-students-page/idp-overlay-student-form'

type Props = {
  postOverlay: (data: IdpOverlayStudentPOST) => Promise<unknown>
}

export default function IdpOverlayStudentCreateButtonModal(props: Props): React.ReactElement {
  const [showModal, setShowModal] = React.useState(false)

  const toggleModal = () => {
    setShowModal(prevState => !prevState)
  }

  const submitForm = useSafeCallbackExtraDeps<
    (overlay: IdpOverlayStudentPOST) => Promise<unknown>,
    {
      postOverlay: (data: IdpOverlayStudentPOST) => Promise<unknown>
      toggleModal: () => void
    }
  >(
    ({postOverlay, toggleModal}) =>
      (overlay: IdpOverlayStudentPOST): Promise<unknown> => {
        return postOverlay(overlay).then(() => toggleModal())
      },
    [],
    {
      postOverlay: {value: props.postOverlay, comparator: () => true},
      toggleModal: {value: toggleModal, comparator: () => true}
    }
  )

  return (
    <React.Fragment>
      <Button onClick={toggleModal} addClass={style.button}>
        Add Overlay
      </Button>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>Create Overlay</DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <IdpOverlayStudentForm onSubmit={unCallbackFn(submitForm)} />
        </div>
      </Dialog>
    </React.Fragment>
  )
}
